import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SalesTransactionAction } from '../api';
import useCompanySetting from './useCompanySetting';

const useSalesTransactionActionOptions = () => {
    const { t } = useTranslation(['saleTransactionsPage']);
    const {
        companySetting: { companyName },
    } = useCompanySetting();

    return useMemo(
        () => [
            {
                value: SalesTransactionAction.Purchased,
                label: t('saleTransactionsPage:action.purchased', { companyName }),
            },
            { value: SalesTransactionAction.Offers, label: t('saleTransactionsPage:action.offers') },
        ],
        [t, companyName]
    );
};

export default useSalesTransactionActionOptions;
